module.exports = __webpack_public_path__ + "assets/32b675bbbc6f718e3fd76b3ae051d7c1.svg";